<script lang="ts">
	import UsersIcon from "@lucide/svelte/icons/users";
	import TruckIcon from "@lucide/svelte/icons/truck";
	import HomeIcon from "@lucide/svelte/icons/home";
	import PackageIcon from "@lucide/svelte/icons/package";
	import DollarSignIcon from "@lucide/svelte/icons/dollar-sign";

	const audiences = [
		{
			icon: UsersIcon,
			title: "Uber or Lyft Drivers",
			description: "Spot properties during rides"
		},
		{
			icon: TruckIcon,
			title: "DoorDash and Delivery Drivers",
			description: "Find leads while delivering"
		},
		{
			icon: PackageIcon,
			title: "Postal Workers, Fedex, UPS",
			description: "Notice properties on routes"
		},
		{
			icon: DollarSignIcon,
			title: "Junk Haulers",
			description: "Spot distressed properties"
		},
		{
			icon: HomeIcon,
			title: "Landscapers and Lawn Crews",
			description: "Working in neighborhoods daily"
		},
		{
			icon: UsersIcon,
			title: "Door-to-Door Salesmen",
			description: "Already visiting properties"
		}
	];
</script>

<div class="animate-fade-in-up-delay space-y-6">
	<h3 class="text-foreground text-xl font-semibold">Perfect For:</h3>

	<div
		class="grid grid-cols-1 gap-x-6 gap-y-8 pt-4 sm:grid-cols-2"
		role="list"
		aria-label="Target audiences"
	>
		{#each audiences as audience}
			<div class="cursor-default space-y-2">
				<div class="flex items-center gap-2">
					<audience.icon class="text-muted-foreground size-4" />
					<h4 class="font-medium">{audience.title}</h4>
				</div>
				<p class="text-gray-600">
					{audience.description}
				</p>
			</div>
		{/each}
	</div>
</div>
